/* NODE Triton — carrossel base (setas + dots + scroll-snap) e autoplay do hero.
   Guard total: o arquivo é incluído por várias seções e não pode redeclarar. */
if (!customElements.get('nd-carousel')) {
  customElements.define(
    'nd-carousel',
    class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-nd-track]');
        if (!this.track) return;
        this.querySelectorAll('[data-nd-prev]').forEach((b) => b.addEventListener('click', () => this.step(-1)));
        this.querySelectorAll('[data-nd-next]').forEach((b) => b.addEventListener('click', () => this.step(1)));
        /* sem nada para rolar (todos os itens cabem): marca o host para a seção poder esconder as setas */
        const syncStatic = () => this.toggleAttribute('data-nd-static', this.track.scrollWidth <= this.track.clientWidth + 4);
        syncStatic();
        window.addEventListener('resize', syncStatic);
        window.addEventListener('load', syncStatic);
        this.counter = this.querySelector('[data-nd-counter]');
        if (this.counter) {
          this.track.addEventListener('scroll', () => {
            clearTimeout(this.cntTick);
            this.cntTick = setTimeout(() => {
              const items = [...this.track.children].filter((c) => !c.hidden);
              const iw = items[0] ? items[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(this.track).gap) || 0) : 1;
              const idx = Math.min(items.length, Math.round(this.track.scrollLeft / iw) + 1);
              this.counter.textContent = idx + ' / ' + items.length;
            }, 80);
          });
        }
        this.dots = this.querySelector('[data-nd-dots]');
        if (this.dots) {
          this.buildDots();
          this.track.addEventListener('scroll', () => {
            clearTimeout(this.dotTick);
            this.dotTick = setTimeout(() => this.syncDots(), 80);
          });
          window.addEventListener('resize', () => this.buildDots());
        }
        if (this.dataset.autoplay === 'true') {
          const arm = () => {
            clearInterval(this.interval);
            this.interval = setInterval(() => this.step(1, true), Number(this.dataset.interval || 6000));
          };
          arm();
          this.addEventListener('pointerenter', () => clearInterval(this.interval));
          this.addEventListener('pointerleave', arm);
        }
      }

      disconnectedCallback() {
        clearInterval(this.interval);
      }

      pages() {
        return Math.max(1, Math.ceil(this.track.scrollWidth / this.track.clientWidth - 0.02));
      }

      buildDots() {
        const n = this.pages();
        this.dots.innerHTML = '';
        if (n < 2) return;
        for (let i = 0; i < n; i++) {
          const b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-label', String(i + 1) + '/' + n);
          b.addEventListener('click', () => this.track.scrollTo({ left: i * this.track.clientWidth, behavior: 'smooth' }));
          this.dots.appendChild(b);
        }
        this.syncDots();
      }

      syncDots() {
        if (!this.dots) return;
        const idx = Math.round(this.track.scrollLeft / this.track.clientWidth);
        [...this.dots.children].forEach((d, i) => d.classList.toggle('is-active', i === idx));
      }

      step(dir, loop) {
        const item = this.track.querySelector(':scope > *:not([hidden])');
        if (!item) return;
        const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
        const w = item.getBoundingClientRect().width + gap;
        const max = this.track.scrollWidth - this.track.clientWidth - 4;
        if (loop && dir > 0 && this.track.scrollLeft >= max) {
          this.track.scrollTo({ left: 0, behavior: 'smooth' });
          return;
        }
        this.track.scrollBy({ left: dir * w, behavior: 'smooth' });
      }
    }
  );
}

/* Abas de liga do carrossel de clubes: filtra cards pelo data-nd-tab */
if (!customElements.get('nd-tabs-carousel')) {
  customElements.define(
    'nd-tabs-carousel',
    class extends HTMLElement {
      connectedCallback() {
        this.carousel = this.querySelector('nd-carousel');
        this.tabs = [...this.querySelectorAll('[data-nd-tab-btn]')];
        this.cards = [...this.querySelectorAll('[data-nd-tab]')];
        if (!this.tabs.length) return;
        this.tabs.forEach((t) => t.addEventListener('click', () => this.select(t.dataset.ndTabBtn)));
        this.select(this.tabs[0].dataset.ndTabBtn);
      }

      select(tab) {
        this.tabs.forEach((t) => t.classList.toggle('is-active', t.dataset.ndTabBtn === tab));
        this.cards.forEach((c) => { c.hidden = c.dataset.ndTab !== tab; });
        const track = this.querySelector('[data-nd-track]');
        if (track) track.scrollTo({ left: 0 });
        if (this.carousel && this.carousel.dots) this.carousel.buildDots();
      }
    }
  );
}
